import { ELEMENT_STYLES } from "../lib/constants";

export default function ElementBadge({ element, children, size = "md" }) {
  const style = ELEMENT_STYLES[element] || ELEMENT_STYLES.ether;
  const padding = size === "sm" ? "px-2.5 py-1 text-xs" : "px-3 py-1.5 text-sm";
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full border ${padding} font-medium`}
      style={{ backgroundColor: style.bg, borderColor: style.border, color: style.text }}
      data-testid={`element-badge-${element}`}
    >
      {children}
    </span>
  );
}
